import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { useEffect } from 'react';

import { SearchMobilePage } from '@/pages/search/search-mobile-page';
import { useMobile } from '@/shared/lib/use-mobile';

/**
 * Mobile fullscreen Search route.  On desktop the existing Cmd+K
 * command palette is the right surface — redirect there so we don't
 * ship two competing UIs.
 */
function SearchRoute() {
  const isMobile = useMobile();
  const navigate = useNavigate();

  useEffect(() => {
    if (!isMobile) {
      void navigate({ to: '/', replace: true });
    }
  }, [isMobile, navigate]);

  if (!isMobile) return null;
  return <SearchMobilePage />;
}

export const Route = createFileRoute('/search')({ component: SearchRoute });
